module.exports = __webpack_public_path__ + "c4a1c748872f9a57ca80d329644c3f35.jpg";